export default __webpack_public_path__ + "static/media/team.e3d1af05.webp";